"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Card_meta_1 = require("../Card.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('header', Card_meta_1.CARD_CATEGORY_KEY, Card_meta_1.CARD_COMPONENT_KEY, ['header']);